import React from "react";
import InputField from "../../../../reusable-components/TNInputField";
import { addDocumentModalFields } from "./constants";
import { useFormContext } from "react-hook-form";
import moment from "moment";
import { DateFormat } from "../../../../enums/dateTimeFormat";
import { getEnumOptions } from "../../../../utils/getDropdownOptions";
import { DocumentTypes } from "../../../../enums/DatabaseEnums";
import PdfUploader from "./PdfUploader";
import { Col, Row } from "antd";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import { FileTypes } from "../../../../enums/FileUploadEnums";

interface AddDocumentsFormsProps {
  fileList?: any[];
  setFileList?: (obj?: any) => void;
  setDocumentUrl?: (url?: string) => void;
  isQuarryDoc?: boolean;
  materials?: [];
}

const AddDocumentsForms = (props?: AddDocumentsFormsProps) => {
  const { fileList, setFileList, setDocumentUrl, isQuarryDoc, materials } =
    props;
  const { setValue } = useFormContext();
  setValue("date", moment().format(DateFormat.MM_DD_YYYY_SLASHED));
  const options = getEnumOptions(DocumentTypes);

  const handleFileRemove = () => {
    setDocumentUrl("");
  };
  return (
    <>
      <Row>
        {addDocumentModalFields(isQuarryDoc, materials)?.map((field) => (
          <ConditionalRender visible={field.visible}>
            <Col span={field.span}>
              <InputField
                name={field.name}
                label={field.label}
                type={field.type}
                requiredField={field.required}
                placeholder={field.placeholder}
                disabled={field.disabled}
                options={field.options}
                maxLength={field.maxLength}
                noResize={field.noResize}
                {...(field.name === "docType"
                  ? {
                      allowClear: true,
                      options: options,
                    }
                  : {})}
              />
            </Col>
          </ConditionalRender>
        ))}
      </Row>
      <div>
        <PdfUploader
          onUploadSuccess={setDocumentUrl}
          onFileRemove={handleFileRemove}
          allowedFileTypes={
            [
              FileTypes.PDF,
              FileTypes.DOC,
              FileTypes.DOCX,
              FileTypes.XLS,
              FileTypes.XLSX,
              FileTypes.CSV,
              FileTypes.JPEG,
              FileTypes.JPG,
              FileTypes.PNG,
            ]}
          maxCount={1}
          fileList={fileList}
          setFileList={setFileList}
        />
      </div>
    </>
  );
};

export default AddDocumentsForms;
